export default {
  LINKS: {
    PROVIDE_SERVICE: '@:NAVIGATION.MY_DOCTOR_POOL.LINKS.PROVIDE_SERVICE',
    REPRESENT_SERVICE: '@:NAVIGATION.MY_DOCTOR_POOL.LINKS.REPRESENT_SERVICE',
    MVZ: '@:NAVIGATION.MY_DOCTOR_POOL.LINKS.MVZ',
    ABOUT: 'Über arztpool',
  },
  COPYRIGHT: 'arztpool 365 GmbH - Alle Rechte vorbehalten.',
  LEGAL: {
    PRACTICES: 'Praxen & MVZ',
    REPRESENTATIVES: 'VertreterInnen',
    ABOUT_US: 'Über uns',
    FAQ: 'FAQ',
    IMPRINT: 'Impressum',
    PRIVACY: 'Datenschutz',
    CONDITIONS: 'AGB',
    CONCENT: 'Ein­wil­li­gungs­ein­stel­lun­gen',
  },
};
